import store from '..'
import _ from 'lodash'
import axios from 'axios'
import API from '@/common/api'
import TVCHANNEL from '@/common/tvchannel'
import LANG from '@/common/lang'

const defaultLang = LANG.valueObj()
const defaultTvNames = function () {
  let result = []
  for (let i = 0; i < 10; i++) {
    result.push({
      name: _.cloneDeep(defaultLang)
    })
  }
  return result
}

export default {
  namespaced: true,
  state: {
    loadChannel: {
      id: '',
      name: '',
      no: '',
      genre: '',
      lang: '',
      logo: ''
    },
    channel: [],
    chLibrary: [],
    defaultCh: [
      'kbs1',
      'kbs2',
      'mbc',
      'sbs'
    ],
    remocon: [],
    listView: {},
    filter: {
      word: '',
      genre: [],
      lang: []
    },
    setting: {
      control: false,
      remoteList: [],
      remoteIcon: [ // 텍스트대신 아이콘으로 나오는 리모콘 버튼id
        'play',
        'stop',
        'pause',
        'previous',
        'rewind',
        'fast_forward',
        'brightness+',
        'brightness-',
        'netflix'
      ],
      remocon: null,
      tvNames: defaultTvNames()
    }
  },
  mutations: {
    listView (state, data) {
      state.listView = data
    },
    initFilter (state) {
      state.filter.word = ''
      state.filter.genre = TVCHANNEL.genre.map(x => x)
      state.filter.lang = TVCHANNEL.lang.map(x => x)
    },
    setFilter (state, data) {
      Object.keys(data).forEach(function (x) {
        state.filter[x] = data[x]
      })
    },
    setChannel (state, data) {
      state.channel = data
    },
    setChLibrary (state, data) {
      state.chLibrary = data
    },
    updateChLogo (state, data) {
      if (data.id) {
        state.channel.find(x => x.id === data.id).logo = data.logo
      } else {
        state.loadChannel.logo = data.logo
      }
    },
    initCh (state) {
      state.loadChannel = {
        id: '',
        name: '',
        no: '',
        genre: '',
        lang: '',
        logo: ''
      }
    },
    chkAllChannel (state, isChecked) {
      state.channel = state.channel.map(x => {
        return {
          ...x,
          checked: isChecked
        }
      })
    },
    initSetting (state) {
      state.setting = {
        control: false,
        remoteList: [],
        remoteIcon: [
          'play',
          'stop',
          'pause',
          'previous',
          'rewind',
          'fast_forward',
          'brightness+',
          'brightness-',
          'netflix'
        ],
        remocon: null,
        tvNames: defaultTvNames()
      }
    },
    setSetting (state, data) {
      Object.keys(data).forEach(function (x) {
        state.setting[x] = data[x]
      })
    }
  },
  actions: {
    addCh ({ state }, data) {
      state.channel.unshift(data)
      return true
    },
    delCh ({ state }, id) {
      state.channel = state.channel.filter(x => x.id !== id)
      return true
    },
    setLoadChannel ({ state }, id) {
      const channel = state.chLibrary.find(x => x.id === id)
      state.loadChannel = id && channel !== null ? Object.assign({ no: '' }, channel) : null
    },
    applyChannel ({ state }, data) {
      const ids = data.ids
      const preset = data.preset || null
      // 기존 채널 ids
      const legacyChannel = state.channel.map(x => x.id)
      /**
       * 추가될 채널 ids (기존채널과 중복X)
       * 프리셋으로 추가하는 채널이면 프리셋 채널번호가 들어감
       */
      const applyChannel = state.chLibrary.filter(x => ids.includes(x.id) && !legacyChannel.includes(x.id)).map(x => {
        const no = !!x.no
          ? x.no
          : !!x.preset && preset !== null
            ? x.preset.find(p => p.id === preset).no
            : ''
        return {
          ...x,
          no: no,
          visible: true,
          checked: false
        }
      })
      // Merge channel - legacy + apply
      const mergeChannel = _.unionBy(applyChannel, state.channel, 'id')
      state.channel = mergeChannel
      return state.channel
    },
    getChannel ({ dispatch, state }) {
      return dispatch('getChData')
    },
    // 개별데이터 (gvf)
    async getChData ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'tv/channel.json'
        })
        const list = res.data.message
        state.channel = list.map(x => {
          return {
            ...x,
            checked: false
          }
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setChannel ({ state }, data) {
      const list = data || state.channel
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'tv/channel.json',
          data: JSON.stringify(list)
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async getRemocon ({ dispatch, state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-remocon',
          func: 'get-all-remocon',
          id: store.state.authentication.requestId
        })
        const items = res.data.message.Items
        const list = Array.from(items)
        state.remocon = list
        return res.data.message.Items
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    getSetting ({ dispatch, commit, state }) {
      // commit('initSetting')
      return dispatch('getSettingData').then(res => {
        // if (!res) {
        //   dispatch('setSetting', state.setting).then(() => {
        //     dispatch('getSettingData')
        //   })
        // }
        return res
      })
    },
    async getSettingData ({ commit, state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'tv/setting.json'
        })
        const setting = state.setting
        state.setting = { ...setting, ...res.data.message }
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        commit('initSetting')
        return false
      }
    },
    async setSetting ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'tv/setting.json',
          data: JSON.stringify(data)
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    chList: (state) => state.channel,
    chLibrary: (state) => state.chLibrary,
    loadChannel: (state) => state.loadChannel,
    getFilter: (state) => state.filter,
    getSetting: (state) => state.setting,
    remoconList: (state) => state.remocon
  }
}
